var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row container-folio"},[_vm._l((_vm.items),function(item){return _c('ss-catalog-item',{key:"item.id",attrs:{"item":item}})}),_vm._v(" "),(_vm.items && _vm.items.length === 0)?_c('p',{staticClass:"text-center"},[_vm._v("Here is going to be placed the list of registered gyms!!!")]):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e697c32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/common/ss_catalog_list.vue
// module id = fknH
// module chunks = 0